import { render, staticRenderFns } from "./BackupModal.vue?vue&type=template&id=8f7b899e&scoped=true"
import script from "./BackupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BackupModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BackupModal.vue?vue&type=style&index=0&id=8f7b899e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7b899e",
  null
  
)

export default component.exports